import { InjectionToken } from '@angular/core';
import { IErrorHandler } from './models/IErrorHandler';
import { IErrorTransform } from './models/IErrorTransform';
import { ILogContextFactory } from './models/ILogContextFactory';
import { ILoggingOptions } from './models/ILoggingOptions';


export const NEW_RELIC_CLIENT = new InjectionToken('NEW_RELIC');
export const ROLLBAR_CLIENT = new InjectionToken('ROLLBAR');
export const LOGGING_OPTIONS = new InjectionToken<ILoggingOptions>('LOGGING_OPTIONS');
export const LOG_CONTEXT_FACTORY = new InjectionToken<ILogContextFactory>('LOGGING_OPTIONS');
export const LOGGING_ERROR_HANDLERS = new InjectionToken<IErrorHandler[]>('LOGGING_ERROR_HANDLERS');
export const ERROR_TRANSFORMS = new InjectionToken<IErrorTransform[]>('ERROR_TRANSFORMS');
